import React from 'react';
import { Typography, List, ListItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  Person as PersonIcon,
  AccessTime as ClockIcon,
  ContentCopyOutlined as DocumentsIcon,
} from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
  },
  list: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(0),
    backgroundColor: '#fff',
    borderRadius: '8px',
  },
  listItem: {
    border: 'solid 1px #619694',
    borderBottom: 'none',
    '&:first-child': {
      borderRadius: '8px 8px 0 0',
    },
    '&:last-child': {
      borderRadius: '0 0 8px 8px',
      borderBottom: 'solid 1px #619694',
    },
    '&:hover': {
      backgroundColor: '#5b8d8b',
      '& p': {
        color: '#fff',
      },
    },
  },
  listItemTitle: {
    fontSize: '14px',
    color: '#586065',
    fontWeight: 'bold',
  },
  activeStatus: {
    padding: '2px 4px',
    marginRight: theme.spacing(0.5),
    backgroundColor: '#5cb85c',
    fontSize: '12px',
    color: '#fff',
    borderRadius: '4px',
  },
  listInfo: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 4px',
    backgroundColor: '#7ba09f',
    fontSize: '12px',
    color: '#fff',
    borderRadius: '4px',
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: '10px',
    },
  },
  count: {
    marginRight: theme.spacing(0.5),
    padding: '2px 4px',
    backgroundColor: '#337ab7',
    fontSize: '12px',
    color: '#fff',
    borderRadius: '4px',
    '& svg': {
      marginLeft: theme.spacing(0.5),
      fontSize: '10px',
    },
  },
  aim: {
    padding: '2px 4px',
    backgroundColor: '#777',
    fontSize: '12px',
    color: '#fff',
    borderRadius: '4px',
  },
}));

const CardSets = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography
        component='div'
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Typography sx={{ color: '#586065' }}>Card Sets</Typography>
        <span
          style={{
            marginLeft: 'auto',
            padding: '2px 8px',
            backgroundColor: '#b0bcd4',
            fontSize: '12px',
            color: '#fff',
            borderRadius: '8px',
          }}
        >
          Hover over items below for more info
        </span>
      </Typography>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Typography component='div' sx={{ width: '100%' }}>
            <Typography
              component='div'
              sx={{ display: 'flex', width: '100%', alignItems: 'center' }}
            >
              <Typography className={classes.listItemTitle}>
                Practice Cards
              </Typography>
              <Typography
                component='div'
                sx={{ marginLeft: 'auto', display: 'flex' }}
              >
                <span className={classes.activeStatus}>Active</span>
                <span className={classes.listInfo}>
                  <PersonIcon />
                  486&nbsp;
                  <ClockIcon />
                  1168
                </span>
              </Typography>
            </Typography>
            <Typography
              component='div'
              sx={{ marginLeft: 'auto', display: 'flex' }}
            >
              <span className={classes.count}>
                35
                <DocumentsIcon />
              </span>
              <span className={classes.aim}>AIM: 30</span>
            </Typography>
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography component='div' sx={{ width: '100%' }}>
            <Typography
              component='div'
              sx={{ display: 'flex', width: '100%', alignItems: 'center' }}
            >
              <Typography className={classes.listItemTitle}>
                Practice Cards
              </Typography>
              <Typography
                component='div'
                sx={{ marginLeft: 'auto', display: 'flex' }}
              >
                <span className={classes.activeStatus}>Active</span>
                <span className={classes.listInfo}>
                  <PersonIcon />
                  486&nbsp;
                  <ClockIcon />
                  1168
                </span>
              </Typography>
            </Typography>
            <Typography
              component='div'
              sx={{ marginLeft: 'auto', display: 'flex' }}
            >
              <span className={classes.count}>
                35
                <DocumentsIcon />
              </span>
              <span className={classes.aim}>AIM: 30</span>
            </Typography>
          </Typography>
        </ListItem>
      </List>
    </div>
  );
};

export default CardSets;
